export default "__VITE_ASSET__BvvAmsxB__"